import type { ClientTheme } from './types';

/**
 * Writes the theme as CSS custom properties consumed by tailwind.config.ts's `brand.*` tokens.
 * Only the 3 colors + 2 fonts + radius in theme.json are set directly; every other UI color
 * (text, surfaces, success/danger states) is a fixed, brand-neutral constant defined in
 * src/index.css / component classes so a client with an unusual brand palette never produces
 * unreadable (WCAG-failing) text - we don't derive contrast colors from arbitrary brand input.
 */
export function applyTheme(theme: ClientTheme): void {
  const root = document.documentElement;
  root.style.setProperty('--brand-primary', theme.colors.primary);
  root.style.setProperty('--brand-accent', theme.colors.accent);
  root.style.setProperty('--brand-bg', theme.colors.background);
  root.style.setProperty('--brand-font-heading', theme.fonts.heading);
  root.style.setProperty('--brand-font-body', theme.fonts.body);
  root.style.setProperty('--brand-radius', `${theme.radiusPx}px`);
  document.title = theme.displayName ? `Tickets - ${theme.displayName}` : 'Tickets';
}
